import { css } from "styled-components";

const focusColor = "#288FF0";

const colors = {
    black: "#000000",
    veryLightPink: "#f2f2f2",
    darkSkyBlue: "#3ea9f5",
    coral: "#f44e4e",
    coin: "#bababa",
    platinum: "#949494",
    fossil: "#6d6d6d",
    storm: "#767676",
    midnight: "#16161d",
    aquaGreen: "#11ebaa",
    jungleGreen: "#087957",
    aquaGreenTwo: "#10ca93",
    charcoalGrey: "#41414d",
    blackDuplicate: "#1f1f1f",
    snow: "#ffffff",
    ink: "#111115",
    charcoalGreyTwo: "#2d2d34",
    concrete: "#dddddd",
    silver: "#cccccc",
    grayDark: "#1f1f25",
    mist: "#F1F3F2",
    pebble: "#43434B",
    charcoalTwo: "#404040",
    cardDarkModeBorder: "#717171",
    focus: focusColor,
    lightGrey: "#DEDEDE",
    ultramarine: "#0225cf",
    mutedRoyalBlue: "#4e66dd",
    marketingCtaPressed: "#e9e9ed",
    darkModeLink: "#dedede",
    limeGreen: "#98e878",
    steel: "#979797",
    maya: "#81B5E7",
    mutedSoftBlue: "#5085B8",
    porpoise: "#737377",
    brick: "#B73B3B",
    rose: "#FFA7A7",
    tangerine: "#FF931E",
    lawn: "#4F8325",
    lime: "#7AC943",
    chartreuse: "#9CE781",
    piratesGold: "#7F7736",
    sunshine: "#FFBF43",
    butter: "#E7D181",
    violet: "#5C02CF",
    grape: "#A37DFF",
    sweetPea: "#B5A7EE",
    sapphire: "#4C7DDD",
    focusBorder: css`
        border: 3px solid ${focusColor};
    `
};

export default colors;
